/* Sfeerbeeld-schakelaar (collectie-toolbar).
   Standaard UIT. Klik → onthoudt de keuze in localStorage en zet
   body.spd-show-sfeer, waarna de CSS de sfeerbeeld-overlay op elke kaart toont.
   De body-class overleeft Dawn's AJAX facet-/sorteer-render; na zo'n render
   wordt de checkbox opnieuw gebonden + gesynchroniseerd.

   De toggle staat in het sorteer-<form>; de change-listener stopt daarom de
   propagatie zodat Dawn's FacetFiltersForm er geen onnodige reload op doet. */
(function () {
  var KEY = 'spd_show_sfeer';

  function isOn() {
    try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }

  function apply() {
    var on = isOn();
    document.body.classList.toggle('spd-show-sfeer', on);
    var toggles = document.querySelectorAll('.spd-sfeer-toggle__input');
    for (var i = 0; i < toggles.length; i++) {
      if (toggles[i].checked !== on) toggles[i].checked = on;
      bind(toggles[i]);
    }
  }

  function bind(cb) {
    if (cb.dataset.spdBound) return;
    cb.dataset.spdBound = '1';
    // Dawn's facet-forms luisteren op 'input' (mobiel) én 'change'; beide stoppen
    // zodat de toggle geen onnodige facet-/sorteer-reload triggert.
    cb.addEventListener('input', function (e) { e.stopPropagation(); });
    cb.addEventListener('change', function (e) {
      e.stopPropagation();
      try { localStorage.setItem(KEY, cb.checked ? '1' : '0'); } catch (err) {}
      apply();
    });
  }

  function init() {
    apply();
    // Na een AJAX-render (filteren/sorteren) verschijnt de toggle opnieuw met
    // z'n server-default (uit); opnieuw binden + synchroniseren.
    if ('MutationObserver' in window) {
      var scope = document.querySelector('#ProductGridContainer') || document.body;
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; apply(); });
      }).observe(scope, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
